export default __webpack_public_path__ + "bead07cdae139b1fb87be4fa2566c1f1.png";